import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as tslib_1 from "tslib";
import { createAxiosClient, formatUrl } from './utilities';
import { GenericErrorResponseCode } from '@tradingblock/types';

function toApiResponse(legacyResponse) {
  return {
    payload: legacyResponse.Payload,
    responseCode: legacyResponse.ResponseCode,
    errors: legacyResponse.Errors
  };
}

export var ApiClient =
/*#__PURE__*/
function () {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  function ApiClient(rootUrl, authKey) {
    _classCallCheck(this, ApiClient);

    this.rootUrl = rootUrl;
    this.authKey = authKey;
    this.http = createAxiosClient(rootUrl, authKey);
    this.config = {
      headers: {}
    };
  }

  _createClass(ApiClient, [{
    key: "authenticated",
    value: function authenticated(authKey) {
      this.config.headers['Authorization'] = authKey || this.authKey;
      return this;
    }
  }, {
    key: "withResponseHandler",
    value: function withResponseHandler(_ref) {
      var onResponse = _ref.onResponse,
          onResponseError = _ref.onResponseError;
      this.http.interceptors.response.use(onResponse, onResponseError);
      return this;
    }
  }, {
    key: "get",
    value: function get(path, params, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var combinedConfig, response, maybeAxios, status, retryAfter;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                combinedConfig = Object.assign({}, this.config, options || {});
                _context.prev = 1;
                _context.next = 4;
                return this.http.get(formatUrl(path, params), combinedConfig);

              case 4:
                response = _context.sent;

                if (!(!response || !response.data)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: null,
                  errors: ['No response received from server']
                });

              case 7:
                return _context.abrupt("return", toApiResponse(response.data));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                // Normalize Axios errors to expose HTTP status (e.g., 429, 401, 403) to callers
                maybeAxios = _context.t0;
                status = maybeAxios && maybeAxios.response && maybeAxios.response.status;

                if (!(status === 429)) {
                  _context.next = 17;
                  break;
                }

                retryAfter = maybeAxios.response && maybeAxios.response.headers && maybeAxios.response.headers['retry-after'];
                return _context.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: null,
                  errors: ['status code 429', retryAfter ? "retry-after: ".concat(String(retryAfter)) : 'rate limited']
                });

              case 17:
                if (!(status === 401 || status === 403)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", {
                  responseCode: status,
                  payload: null,
                  errors: [maybeAxios && maybeAxios.message ? maybeAxios.message : "HTTP ".concat(status)]
                });

              case 19:
                console.error('API request failed:', _context.t0);
                return _context.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: null,
                  errors: [maybeAxios && maybeAxios.message ? maybeAxios.message : 'Unknown error occurred']
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));
    }
  }, {
    key: "getBinary",
    value: function getBinary(path, params, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var combinedConfig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                combinedConfig = Object.assign({}, this.config, options || {});
                return _context2.abrupt("return", this.http.get(formatUrl(path, params), Object.assign({}, combinedConfig, {
                  responseType: 'arraybuffer'
                })));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "post",
    value: function post(path, payload, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _a, queryParams, config, combinedConfig;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _a = options || {
                  queryParams: undefined
                }, queryParams = _a.queryParams, config = tslib_1.__rest(_a, ["queryParams"]);
                combinedConfig = Object.assign({}, this.config, config);
                return _context3.abrupt("return", this.http.post(formatUrl(path, queryParams || undefined), payload, combinedConfig).then(function (res) {
                  return res.data;
                }).then(toApiResponse));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "put",
    value: function put(path, payload, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _a, queryParams, config, combinedConfig;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _a = options || {
                  queryParams: undefined
                }, queryParams = _a.queryParams, config = tslib_1.__rest(_a, ["queryParams"]);
                combinedConfig = Object.assign({}, this.config, config);
                return _context4.abrupt("return", this.http.put(formatUrl(path, queryParams || undefined), payload, combinedConfig).then(function (res) {
                  return res.data;
                }).then(toApiResponse));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete(path, params, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var combinedConfig;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                combinedConfig = Object.assign({}, this.config, options || {});
                return _context5.abrupt("return", this.http.delete(formatUrl(path, params), combinedConfig).then(function (res) {
                  return res.data;
                }).then(toApiResponse));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return ApiClient;
}();
export var UiApiClient =
/*#__PURE__*/
function () {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  function UiApiClient(rootUrl, authKey) {
    _classCallCheck(this, UiApiClient);

    this.rootUrl = rootUrl;
    this.authKey = authKey;
    this.http = createAxiosClient(rootUrl, authKey);
    this.config = {
      headers: {}
    };
  }

  _createClass(UiApiClient, [{
    key: "authenticated",
    value: function authenticated(authKey) {
      this.config.headers['Authorization'] = authKey || this.authKey;
      this.config.withCredentials = true;
      return this;
    }
  }, {
    key: "with",
    value: function _with(func) {
      this.config = func(this.config);
      this.config.withCredentials;
      return this;
    }
  }, {
    key: "withResponseHandler",
    value: function withResponseHandler(_ref2) {
      var onResponse = _ref2.onResponse,
          onResponseError = _ref2.onResponseError;
      this.http.interceptors.response.use(onResponse, onResponseError);
      return this;
    }
  }, {
    key: "get",
    value: function get(path, params, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var combinedConfig;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                combinedConfig = Object.assign({}, this.config, options || {});
                return _context6.abrupt("return", this.http.get(formatUrl(path, params), combinedConfig).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "post",
    value: function post(path, payload, options) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _a, queryParams, config, combinedConfig;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _a = options || {
                  queryParams: undefined
                }, queryParams = _a.queryParams, config = tslib_1.__rest(_a, ["queryParams"]);
                combinedConfig = Object.assign({}, this.config, config);
                return _context7.abrupt("return", this.http.post(formatUrl(path, queryParams || undefined), payload, combinedConfig).then(function (res) {
                  return res.data;
                }));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return UiApiClient;
}();